import { FC } from 'react';
import styled from '@emotion/styled';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Tooltip, withStyles } from '@material-ui/core';

type Props = {
  text: string;
};

const IconWrapper = styled('div')({
  display: 'inline-block',
  marginLeft: '0.3em',
  lineHeight: 0,
});

const HtmlTooltip = withStyles(() => ({
  tooltip: {
    padding: '10px',
    fontSize: '1em',
    textAlign: 'left',
    fontWeight: 700,
    backgroundColor: 'black',
  },
}))(Tooltip);

const HelpIcon = styled(HelpOutlineIcon)({
  width: '12px',
  height: '12px',
});

const HelpTip: FC<Props> = ({ text }) => {
  return (
    <HtmlTooltip title={text} placement="top">
      <IconWrapper>
        <HelpIcon />
      </IconWrapper>
    </HtmlTooltip>
  );
};

export default HelpTip;
